import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {POST_UPDATE_VALID_CEQ_TEST_DATES_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface UpdateValidCeqTestDateModelRequest {
  validCeqTestDateUuid: string;
  registrationExamLevelUuid: string;
  firstAcceptedCeqTestDate: string;
  lastAcceptedCeqTestDate: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostUpdateValidCeqTestDates = ({onSuccess, onError}: Input) => {
  const postUpdateValidCeqTestDates = async (payload: UpdateValidCeqTestDateModelRequest) => {
    const res = await axiosClient.post<void>(
        POST_UPDATE_VALID_CEQ_TEST_DATES_URL(payload.validCeqTestDateUuid),
        payload
    );
    return res.data;
  };

  return useCustomMutation(postUpdateValidCeqTestDates, {
    onSuccess,
    onError,
  });
};
